import {Attributes} from 'platform/components';

import {PersonResponseBodyV2} from '@dms/api/customer';
import {useCustomerPersonAttributes} from '@dms/shared';

import {suffixTestId, TestIdProps} from 'shared/web';

export interface PersonInfoProps {
  person?: PersonResponseBodyV2 | null;
  showRole?: boolean;
  showEmails?: boolean;
  showPhoneNumbers?: boolean;
  showPersonalIdentifier?: boolean;
  selfEmployed?: boolean | null;
}

export const PersonInfo = ({
  person,
  showRole,
  showEmails,
  showPhoneNumbers,
  selfEmployed,
  showPersonalIdentifier = true,
  ...rest
}: PersonInfoProps & TestIdProps) => {
  const [getAttributes] = useCustomerPersonAttributes();

  if (!person) {
    return null;
  }

  return (
    <Attributes
      data-testid={suffixTestId('personInfo', rest)}
      rows={getAttributes(person, {
        isRoleHidden: !showRole,
        isEmailsHidden: !showEmails,
        isPhoneNumbersHidden: !showPhoneNumbers,
        isPersonalIdentifierHidden: !showPersonalIdentifier,
      })}
      size="quarter"
    />
  );
};
